import { render } from "./DescriptionAndObjectives.vue?vue&type=template&id=42f2959b&scoped=true"
import script from "./DescriptionAndObjectives.vue?vue&type=script&lang=js"
export * from "./DescriptionAndObjectives.vue?vue&type=script&lang=js"

import "./DescriptionAndObjectives.vue?vue&type=style&index=0&id=42f2959b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f2959b"]])

export default __exports__